<template>
	<div>
      	<select ref="phonePrefix" class="form-control" @change="onPrefixSelected"></select>
	</div>
</template>

<script>
	export default {
		model: {
			prop: 'value',
		},
		props: ['cname', 'value'],
		data() {
			return {
				id: Math.random().toString().replace(".",""),
				selectedValue: this.value,
				componentName: this.cname || 'prefix'
			}
		},
		mounted() {
			this.initPrefixes()
		},
		methods: {
			onPrefixSelected(event) {
				this.$emit('geo-changed', {
          			key: 'prefix',
					value: $(event.target).val(),
					component: this.componentName
				})
			},
			setSelectedValue(newValue) {
                this.selectedValue = newValue
            },
            getSelectedValue() {
                return this.selectedValue
            },
			initPrefixes() {
				const $select = $(this.$refs.phonePrefix)

				$select.attr("id", this.id)
				$select.html('')

				if(this.selectedValue && this.selectedValue.hasOwnProperty("dial_code")) {
					this.selectedValue = this.value["dial_code"]
				}

				this.loadAllPhonePrefixes().then((res) => {
					this.writeOptionsInSelect($select, "dial_code", "dial_code", res.phonePrefixes, this.selectedValue, [], null, (obj) => {
                        return obj["dial_code"] + " (" + obj["code"] + ")"
                    });
				});     
			},
			getSelect() {
				return $(this.$refs.phonePrefix)
			}
		}
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/purchases/VoucherPartecipantPhonePrefix.vue